import {useInternationalization} from "@progress/kendo-react-intl"
import {Card, CardBody} from "@progress/kendo-react-layout"
import {Popup} from "@progress/kendo-react-popup"
import {MDBCol, MDBRow} from "mdbreact"
import React, {useRef} from "react"
import {setTestPackagePopupShow} from "../../../containers/MotBooking/bookingSlice"
import {RootState} from "../../../rootReducer"
import {useAppSelector, useAppDispatch} from "../../../store"

const TestPackagePopUp = ({show, anchor}: {show: boolean; anchor: any}) => {
    // const [current]=anchor
    const dispatch = useAppDispatch()
    const dvsaTests = useAppSelector((state: RootState) => state.containers.motBooking.dvsTests)
    const contentRef = useRef<any>()
    const blurTimeoutRef = useRef<any>()
    const intl = useInternationalization()
    const onOpenSchPopover = () => {
        contentRef.current.focus()
    }
    const onFocusSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
    }
    const onBlurSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
        blurTimeoutRef.current = setTimeout(onBlurTimeout, 200)
    }

    const onBlurTimeout = () => {
        dispatch(setTestPackagePopupShow(false))
    }

    return (
        <Popup
            className={"mt-3"}
            show={show}
            anchor={anchor.current}
            popupClass={"popup-content"}
            onOpen={onOpenSchPopover}
            anchorAlign={{
                horizontal: "right",
                vertical: "center",
            }}
            popupAlign={{
                horizontal: "right",
                vertical: "top",
            }}
        >
            <div
                style={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    width: "30vw",
                }}
                ref={contentRef}
                tabIndex={0}
                onFocus={onFocusSchPopover}
                onBlur={onBlurSchPopover}
            >
                <div>
                    <MDBRow className="m-0">
                        {dvsaTests?.map((test, index) => (
                            <MDBCol key={`test_item_${index}`} md="6" className="ps-2 pe-0">
                                <Card className="m-2 me-1 ms-0 shadow-3">
                                    <CardBody className="p-3">
                                        <h6>{test.code}</h6>
                                        <p>
                                            {test.test}
                                            <hr className="mt-2" />
                                        </p>

                                        <MDBRow>
                                            <MDBCol md="6">Axle</MDBCol>
                                            <MDBCol md="6">{test.axle}</MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol md="6">Duration</MDBCol>
                                            <MDBCol md="6">{test.duration} min</MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol md="6">Test Fee</MDBCol>
                                            <MDBCol md="6">
                                                {intl.formatNumber(test.charges, {
                                                    style: "currency",
                                                    minimumFractionDigits: 2,
                                                })}
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow className="pt-2">
                                            <MDBCol md="12">{test.testType}</MDBCol>
                                        </MDBRow>
                                    </CardBody>
                                </Card>
                            </MDBCol>
                        ))}
                    </MDBRow>
                </div>
            </div>
        </Popup>
    )
}

export default TestPackagePopUp
